import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { config } from '@/config'
import { logger } from '@/lib'

export const useGtm = () => {
  const gtmDispatch = useGTMDispatch()
  const sendDataToGTM = config.gtmId ? gtmDispatch : logger.log

  return {
    sendDataToGTM,
  }
}
